import APIManagerRemoteApi, { APIPolicyBody } from '../../../../remote-api/APIManagerRemoteApi'
import { APIDetail, APIPolicy, APIPolicyConfiguration } from '../../../../remote-api/models'
import { LogPointsRuntimeHelper, RuntimeMajor, RuntimeSupport } from './LogPointsRuntimeHelper'
import { isFlex } from '../../../../util/flex'

export class LogPointsMuleThreeHelper extends LogPointsRuntimeHelper {

  private static readonly GATEWAY_COMPATIBILITY_REGEX: RegExp = /(>=|>|<=|<)/
  private static readonly DEFAULT_POLICY_VERSION: string = 'v10'

  private readonly remoteAPI: APIManagerRemoteApi

  constructor(remoteAPI: APIManagerRemoteApi) {
    super(RuntimeMajor.MULE_THREE)

    this.remoteAPI = remoteAPI
  }

  async fetchMessageLoggingPolicy(orgId: string, envId: string, apiId: string): Promise<APIPolicy | undefined> {
    const policies = await this.remoteAPI.fetchAPIPolicies(orgId, envId, apiId)
    const policyFinder = (policy: APIPolicy) => policy.policyTemplateId.toString() === LogPointsRuntimeHelper.POLICY_ID

    return policies.find(policyFinder)
  }

  async getAPIPolicyBody(api: APIDetail, configuration: APIPolicyConfiguration, policy?: APIPolicy): Promise<APIPolicyBody> {
    return {
      apiId: Number(api.id),
      configurationData: configuration,
      id: policy ? policy.id : null,
      pointcutData: null,
      policyTemplateId: LogPointsRuntimeHelper.POLICY_ID,
      policyVersion: policy && policy.policyVersion ? policy.policyVersion : LogPointsMuleThreeHelper.DEFAULT_POLICY_VERSION
    }
  }

  canHandle(api: APIDetail): boolean {
    return !isFlex(api) && api.endpoint && !api.endpoint.muleVersion4OrAbove
  }

  protected async fetchMinMuleVersion(orgId: string): Promise<string | undefined> {
    const policyTemplates = await this.remoteAPI.fetchPolicyTemplates(orgId)
    const maybePolicyTemplate = policyTemplates.find(template => template.id === LogPointsRuntimeHelper.POLICY_ID)

    return maybePolicyTemplate ?
      maybePolicyTemplate.gatewayCompatibility.split(LogPointsMuleThreeHelper.GATEWAY_COMPATIBILITY_REGEX)[2] :
      undefined
  }

  protected getDefaultRuntimeSupport(): RuntimeSupport {
    return {minMuleVersion: {major: 3, minor: 8, patch: 5}}
  }
}
